export default __webpack_public_path__ + "static/media/howPage-whatTab.22d10826.svg";